import React, {useEffect, useState} from "react";
import Select from "react-select";
import Loader from "../../components/loaders/Loader";
import "./connect-and-verify-an.scss";
import { useNavigate } from "react-router-dom";
import {AUTH_TOKEN, USER_ROLE, USER_ID} from "../../constants/Auth";
import {logOut} from "../../redux/dataUploader/dataSlice";
import {useDispatch} from "react-redux";

const ConnectAndVerifyAN = () => {

    const role = localStorage.getItem(USER_ROLE);
    const userId = localStorage.getItem(USER_ID);
    const [usersList, setUsersList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedUser, setSelectedUser] = useState({
        id: localStorage.getItem("id"),
        name: localStorage.getItem("name"),
    });
    const [affiliateNetworksList, setAffiliateNetworksList] = useState([]);
    const [affiliateNetworksShortNamesList, setAffiliateNetworksShortNamesList] = useState([]);
    const [aNShortName, setANShortName] = useState(null);
    const [affiliateNetwork, setAffiliateNetwork] = useState(null);
    const [blogsList, setBlogsList] = useState([]);
    const [selectedBlog, setSelectedBlog] = useState(null);
    const [newBlogValue, setNewBlogValue] = useState(null);
    const [companiesList, setCompaniesList] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [tempProjectsList, setTempProjectsList] = useState([]);
    const [projectsList, setProjectsList] = useState([]);
    const [selectedProject, setSelectedProject] = useState(null);
    const [formContent, setFormContent] = useState([]);
    const [selectedAffiliateNetwork, setSelectedAffiliateNetwork] = useState(null);
    const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
    const [confirmationPopupText, setConfirmationPopupText] = useState("");
    const [formError, setFormError] = useState(false);
    const [formErrorMessage, setFormErrorMessage] = useState([]);
    const [successfullSendData, setSuccessfullSendData] = useState(false);
    const [successfullSendDataMessage, setSuccessfullSendDataMessage] = useState([]);
    const [trackingDomain, setTrackingDomain] = useState('');
    const [credentialsValues, setCredentialsValues] = useState({});
    const [fullName, setFullName] = useState(null); 
    const [companyNameExists, setCompanyNameExists] = useState(true);
    const [credentialsCheckbox, setCredentialsCheckbox] = useState(true);
    const [hasVoluumAccountCheckbox, setHasVoluumAccountCheckbox] = useState(true);
    const [copied, setCopied] = useState(false);

    const dispatch = useDispatch();
    const token = localStorage.getItem("auth_token");
    const navigate = useNavigate();

    useEffect(() => {
        if(role !== 'admin') {
            if(userId !== '43' && userId !== '135') {
                navigate('/not-found');
            }
        }
    }, [role, navigate]);    

    useEffect(() => {
        if(selectedCompany && 
            selectedProject &&
            selectedBlog) {
                const anShortName = affiliateNetworksShortNamesList.find(item => item.label === affiliateNetwork.label);
                setFullName(`${selectedCompany.name} - ${anShortName.value} - ${selectedBlog.value} - ${selectedProject.label}`);
            }
    }, [selectedCompany, selectedProject, selectedBlog])

    const checkSession = (status) => {
        if(status === 401) {
            dispatch(logOut());
        }
    }

    const selectStyles = {
        container: (baseStyles) => ({
            ...baseStyles,
            maxWidth: "180px",
            width: "100%",
            margin: "0 20px 0 0",
        }),
        control: (baseStyles, state) => ({
            ...baseStyles,
            fontSize: "14px",
            lineHeight: "1.2",
            minHeight: "26px",
            border: "none",
            borderRadius: "8px",
            "&:hover": {
                cursor: "pointer",
            },
        }),
        placeholder: (baseStyles) => ({
            ...baseStyles,
            fontWeight: 500,
            color: "#1A3353",
        }),
        menu: (baseStyles, state) => ({
            ...baseStyles,
            zIndex: "6",
            "&:hover": {
                cursor: "pointer",
            },
        }),
        option: (baseStyles, state) => ({
            ...baseStyles,
            fontSize: "14px",
            lineHeight: "1.2",
            "&:hover": {
                cursor: "pointer",
            },
        }),
    }

    const formSelectStyles = {
        container: (baseStyles) => ({
            ...baseStyles,
            maxWidth: "322px",
            width: "100%",
            margin: "0 20px 0 0",
            borderRadius: "6px",
            border: "1px solid #b7b7b7",
        }),
        control: (baseStyles, state) => ({
            ...baseStyles,
            fontSize: "14px",
            lineHeight: "1.2",
            minHeight: "26px",
            border: "none",
            borderRadius: "8px",
            "&:hover": {
                cursor: "pointer",
            },
        }),
        placeholder: (baseStyles) => ({
            ...baseStyles,
            fontWeight: 400,
            color: "#737373",
        }),
        menu: (baseStyles, state) => ({
            ...baseStyles,
            zIndex: "6",
            "&:hover": {
                cursor: "pointer",
            },
        }),
        option: (baseStyles, state) => ({
            ...baseStyles,
            fontSize: "14px",
            lineHeight: "1.2",
            "&:hover": {
                cursor: "pointer",
            },
        }),
    }

    const fetchUserAccountDetails = (userId) => {

        fetch(`${localStorage.getItem("apiUrl")}api/user/account-details/${userId || selectedUser.id}`, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
        })
        .then(res => {
            checkSession(res.status);
            if (res.ok) {
                return res.json()
            }
            return Promise.reject(res)
        })
        .then(res => {
            if (res.data["affiliate_networks"] && Object.keys(res.data["affiliate_networks"]).length > 0) {
                const an = Object.entries(res.data["affiliate_networks"]).map(([key, value]) => ({
                        value: key,
                        label: value
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label));
                setAffiliateNetworksList(an);
            }
            if (res.data["affiliate_networks_short_names"] && Object.keys(res.data["affiliate_networks_short_names"]).length > 0) {
                const an = Object.entries(res.data["affiliate_networks_short_names"]).map(([key, value]) => ({
                        value: key,
                        label: value
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label));
                setAffiliateNetworksShortNamesList(an);
            }
            if (res.data["blogs"] && Object.keys(res.data["blogs"]).length > 0) {
                const blogs = Object.entries(res.data["blogs"]).map(([key, value]) => ({
                        value: key,
                        label: value
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label));
                setBlogsList(blogs);
            }
            // if blogs - empty array
            if (Array.isArray(res.data["blogs"]) && res.data["blogs"].length === 0) {
                setBlogsList([]);
            }       
            if (Array.isArray(res.data['companies']) && res.data['companies'].length > 0) {
                const companies = res.data['companies']
                    .filter((c) => c && c.id != null && c.company_name)
                    .map((c) => ({
                        value: String(c.id),
                        label: String(c.company_full_name),
                        name: String(c.company_name)
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label));

                setCompaniesList(companies);
            }
            if (res.data["projects"] && Object.keys(res.data["projects"]).length > 0) {
                const projects = Object.entries(res.data["projects"]).map(([key, value]) => ({
                        value: key,
                        label: value
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label));
                setTempProjectsList(projects);
            }
        })
        .catch(res => {
            setConfirmationPopupText("Something went wrong")
            setShowConfirmationPopup(true)
        });
        
    };

    useEffect(() => {

        if(selectedBlog) {
            setIsLoading(true);

            const anShortName = affiliateNetworksShortNamesList.find(item => item.label === affiliateNetwork.label);
            
            const payload = {
                company_name: selectedCompany.name,
                an_name: anShortName.value,
                project_name: selectedProject.label,
                blog_name: selectedBlog.value,
            };

            // initial fetch
            fetch(`${localStorage.getItem("apiUrl")}api/service-credential-name-check`, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                method: "POST",
                body: JSON.stringify(payload)
            })
            .then(res => {
                checkSession(res.status);
                if (res.ok) {
                    return res.json()
                }
                return Promise.reject(res)
            })
            .then(res => {
                if(!res.exists) {
                    setCompanyNameExists(false);
                } else {
                    setFormError(true);
                    setCompanyNameExists(true);
                    setFormErrorMessage([`Already exist`]);
                }
                setIsLoading(false);
            })
            .catch(res => {
                setIsLoading(false);
                setConfirmationPopupText("Something went wrong");
                setShowConfirmationPopup(true);
            })
        }

    }, [selectedBlog]);

    useEffect(() => {
        setIsLoading(true);

        // initial fetch
        fetch(`${localStorage.getItem("apiUrl")}api/user/${selectedUser.id}/services?status=true&is_archived=false`, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
        })
        .then(res => {
            checkSession(res.status);
            if (res.ok) {
                return res.json()
            }
            return Promise.reject(res)
        })
        .then(res => {

            setSelectedUser({id: res.id, name: res.name})
            setUsersList([...res["user_managers_accounts"]])
            fetchUserAccountDetails();
            setIsLoading(false);
        })
        .catch(res => {
            setIsLoading(false)
            setConfirmationPopupText("Something went wrong")
            setShowConfirmationPopup(true)
        })
    }, []);

    const handleChangeSelectedUser = (user) => {
        setSelectedAffiliateNetwork(null);
        setAffiliateNetwork(null);
        fetchUserAccountDetails(user.value);
        setFormContent([]);
        setFormError(false);
        setFormErrorMessage([]);
        setSuccessfullSendData(false);
        setSuccessfullSendDataMessage([]);
        setCredentialsValues({});
        setCompaniesList([]);
        setBlogsList([]);
        setProjectsList([]);
        setCompanyNameExists(true);
        setSelectedUser({id: user.value, name: user.label});
    }

    const handleChangeAffiliateNetworks = (an) => {
        setIsLoading(true);
        setAffiliateNetwork(an);
        setFormContent([]);
        setFormError(false);
        setFormErrorMessage([]);
        setSuccessfullSendData(false);
        setSuccessfullSendDataMessage([]);
        setSelectedCompany(null);
        setSelectedProject(null);
        setSelectedBlog(null);
        setCredentialsValues({});
        setBlogsList([]);
        setProjectsList([]);
        setCompanyNameExists(true);
        setFullName(null);

        fetch(`${localStorage.getItem("apiUrl")}api/service-credential-form/${an.value}`, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
        })
        .then(res => {
            checkSession(res.status);
            if (res.ok) {
                return res.json()
            }
            return Promise.reject(res)
        })
        .then(res => {
            const jsonForm = JSON.parse(res.json_form);
            setFormContent(jsonForm);
    
            setSelectedAffiliateNetwork(an);
            setIsLoading(false);
        })
        .catch(res => {
            setIsLoading(false)
            setConfirmationPopupText("Something went wrong")
            setShowConfirmationPopup(true)
        })
    }

    const changeSelectedCompany = (companyOption) => {
        setProjectsList([]);
        setSelectedProject(null);
        setSelectedCompany(companyOption);
        setSelectedBlog(null);
        setBlogsList([]);
        setCompanyNameExists(true);        
        setFormError(false);
        setFormErrorMessage([]);
        setFullName(null);

        // get blogs related to this company 
        fetch(`${localStorage.getItem("apiUrl")}api/${companyOption.value}/blogs`, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
        })
        .then(res => {
            checkSession(res.status);
            if (res.ok) {
                return res.json()
            }
            return Promise.reject(res)
        })
        .then(res => {
            if (Array.isArray(res) && res.length > 0) {
                const blogs = res
                    .filter((blog) => blog && blog.short_name != null && blog.domain)
                    .map((blog) => ({
                        value: String(blog.short_name),
                        label: String(blog.domain)
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label));

                setBlogsList(blogs);
            }
        })
        .catch(res => {
            setConfirmationPopupText("Something went wrong")
            setShowConfirmationPopup(true)
        })

        const filteredProjects = tempProjectsList.filter(project => project.value === companyOption.name);
        setProjectsList(filteredProjects);
    }

    const changeSelectedBlog = (option) => {
        setFormError(false);
        setFormErrorMessage([]);
        setFullName(null);
        setSelectedBlog(option);
    }
        

    const validateFirstSection = () => {
        let valid = false;
        let emptyFields = [];
        if(!selectedCompany) {
            setFormError(true);
            emptyFields.push('Company Name');
            valid = false;
        }
        if(!selectedProject) {
            setFormError(true);
            emptyFields.push('Project Name');
            valid = false;
        }
        if(!selectedBlog) {
            setFormError(true);
            emptyFields.push('Blog Name');
            valid = false;
        }

        if(!valid) setFormErrorMessage([`Please choose all required fields: ${emptyFields.join(`, `)}`]);
        if(selectedCompany && selectedProject && selectedBlog) valid = true;
        return valid;
    }

    const sendData = () => {
        const valid = validateFirstSection();
        const toNumberBool = (v) => (v ? 1 : 0);

        if(!valid) return;

        let hasEmpty = false;
        let emptyFields = [];

        formContent.forEach(section => {
            section.fields.forEach(field => {
                if (field.required) {
                    let value = '';
                    if (field.name === "company_name") {
                        value = selectedCompany.name;
                    } else if (field.name === "project_name") {
                        value = selectedProject.label;
                    } else if (field.name === "blog_name") {
                        value = selectedBlog.value;
                    } else {
                        const input = document.querySelector(`input[name="${field.name}"]`);
                        value = input ? input.value : '';
                    }
                    if (!value || value.trim() === '') {
                        hasEmpty = true;
                        emptyFields.push(field.label);
                    }
                }
            });
        });

        if (hasEmpty && hasVoluumAccountCheckbox) {
            setFormError(true);
            setFormErrorMessage([`Please fill in all required fields: ${emptyFields.join(`, `)}`]);
            return;
        } else {
            setFormError(false);
            setFormErrorMessage([]);
        }

        setIsLoading(true);

        const data = new FormData();
        data.append('check_credentials', toNumberBool(credentialsCheckbox));
        data.append('has_voluum_account', toNumberBool(hasVoluumAccountCheckbox));
        let validationFailed = false;

        const domainRegex = /([\wЁёА-я\d-]{2,})\.([\wЁёА-я\d-]{2,})/;

        formContent.forEach(section => {
            section.fields.forEach((field, fIdx) => {
                let value = '';

                if (field.name === "company_name") {
                    value = selectedCompany.name;
                } else if (field.name === "project_name") {
                    value = selectedProject.label;
                } else if (field.name === "blog_name") {
                    value = selectedBlog.value;
                } else {
                    const input = document.querySelector(`input[name="${field.name}"]`);
                    value = input ? input.value : (credentialsValues[field.name] ?? '');
                }

                if (field.name === "voluum_tracking_domain") {

                    const cleaned = String(value || '')
                        .trim()
                        .replace(/^https?:\/\//i, '')
                        .replace(/^www\./i, '')
                        .replace(/\/+$/g, '')
                        .toLowerCase();
 
                    const checkDomain = domainRegex.test(cleaned);
                    if (!checkDomain && hasVoluumAccountCheckbox) {
                        validationFailed = true;
                        setFormError(true);
                        setFormErrorMessage(['Enter valid tracking domain. Ex: domain.com']);
                        data.append(field.name, cleaned);
                        return;
                    } else {
                        setFormError(false);
                        setFormErrorMessage([]);
                        value = cleaned;
                    }
                }
                
                data.append(field.name, value);
            });
        });

        if (validationFailed) {
            setIsLoading(false);
            return;
        }
        
        fetch(`${localStorage.getItem("apiUrl")}api/service-credential-form/${affiliateNetwork.value}`, {
            headers: {
                "Accept": "application/json",
                "Authorization": `Bearer ${token}`,
            },
            method: "POST",
            body: data
        })
        .then(res => {
            checkSession(res.status);
            return res.json();
        })
        .then(res => {
            if(res.status) {
                setIsLoading(false);
                setSelectedAffiliateNetwork(null);
                setFormContent([]);
                setFormError(false);
                setFormErrorMessage();
                setSelectedProject(null);
                setSelectedBlog(null);
                setSelectedCompany(null);
                setSuccessfullSendDataMessage(['Account has been added to Optim8:', `id: ${res.id}`, `name: ${res.name}`]);
                setSuccessfullSendData(true);
                setAffiliateNetwork(null);
                setCredentialsValues({});
                setFullName(null);
            } else if(res.errors.message) {
                setFormError(true);
                setFormErrorMessage([res.errors.message]);
                setIsLoading(false);
                    
            } else {
                const allErrors = [];
                Object.values(res.errors).forEach(errorArr => {
                    if (Array.isArray(errorArr)) {
                        allErrors.push(...errorArr);
                    }
                });
                setFormError(true);
                setFormErrorMessage(allErrors);
                setIsLoading(false);
                
            }           
        })
        .catch(res => {
            setIsLoading(false)
            setConfirmationPopupText("Something went wrong");
            setShowConfirmationPopup(true);
        })
    }

    const handleCredentialsChange = (fieldName, value) => {
        setCredentialsValues(prev => ({ ...prev, [fieldName]: value }));
    };

    const handleAddNewDomain = (value, e) => {
        e.preventDefault();

        const domainRegex = /([\wЁёА-я\d-]{2,})\.([\wЁёА-я\d-]{2,})/;

        const cleaned = String(value || '')
            .trim()
            .replace(/^https?:\/\//i, '')
            .replace(/^www\./i, '')
            .replace(/\/+$/g, '')
            .toLowerCase();

        const checkDomain = domainRegex.test(cleaned);

        if (!checkDomain) {
            setFormError(true);
            setFormErrorMessage(prev => [...(Array.isArray(prev) ? prev : []), 'Enter valid domain for a new blog. Ex: domain.com']);
            return;
        } else {
            setFormError(false);
            setFormErrorMessage([]);
        }

        const newOption = { value: cleaned, label: cleaned };

        setBlogsList(prev => {
            const exists = prev && prev.some(b => String(b.value).toLowerCase() === cleaned);
            if (exists) return prev;
            return [newOption, ...(prev || [])];
        });
        
        setSelectedBlog(newOption);
        setNewBlogValue(null)
    }

    const handleCopy = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    if (isLoading) {
        return <div className='loading-wrap'><Loader/></div>
    }

    return (
        <>
            <div className={`changed-campaigns-container`}>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    margin: "0 0 10px",
                }}>

                    <Select
                        className={""}
                        styles={selectStyles}
                        options={usersList.length !== 0 ? usersList
                            .slice()
                            .sort((a, b) => a.name.localeCompare(b.name))
                            .reduce((acc, item) => {
                            acc.push({value: item.id, label: item.name})
                            return acc
                        }, []) : [{value: selectedUser.id, label: selectedUser.name}]}
                        isSearchable={true}
                        defaultValue={{value: selectedUser.id, label: selectedUser.name}}
                        name={"ac-username"}
                        placeholder={"User"}
                        components={{
                            IndicatorSeparator: () => null
                        }}
                        onChange={(option) => handleChangeSelectedUser(option)}
                    />

                    <Select
                        className={""}
                        styles={selectStyles}
                        options={affiliateNetworksList
                            .slice()
                            .sort((a, b) => a.label.localeCompare(b.label))
                        }
                        isSearchable={true}
                        value={selectedAffiliateNetwork || null}
                        name={"affiliate_network_account"}
                        placeholder={"Affiliate Networks"}
                        components={{
                            IndicatorSeparator: () => null
                        }}
                        onChange={(option) => handleChangeAffiliateNetworks(option)}
                    />
                </div>
            </div>

            {formContent.length > 0 && (
                <div className="formContainer">
                    <form
                        className="compaign-form"
                        onSubmit={(e) => {
                            e.preventDefault();
                            sendData();
                        }}
                    >
                        <div className="form-section">
                            <h3 className="section-title">{formContent[0].sectionTitle}</h3>
                            {formContent[0].fields.map((field, fieldIndex) => (
                                <div key={fieldIndex} className="form-field">
                                    <label htmlFor={field.name} className="field-label">{field.label}</label>
                                    <Select
                                        className={""}
                                        styles={formSelectStyles}
                                        options={field.name === "company_name" ? companiesList :
                                            field.name === "project_name" ? projectsList : 
                                            field.name === "blog_name" ? blogsList : []}
                                        isSearchable={true}
                                        value={field.name === "company_name" ? selectedCompany : 
                                            field.name === "project_name" ? selectedProject : 
                                            field.name === "blog_name" ? selectedBlog : null}
                                        name={field.name}
                                        placeholder={field.placeholder}
                                        components={{
                                            IndicatorSeparator: () => null
                                        }}
                                        onChange={field.name === "company_name" ? (option) => changeSelectedCompany(option) :
                                            field.name === "project_name" ? (option) => setSelectedProject(option) : 
                                            field.name === "blog_name" ? (option) => changeSelectedBlog(option) : null
                                        }
                                    />
                                </div>
                            ))}
                            {/* <div className="form-field flex-input">
                                <label htmlFor="add-new-blog" className="field-label">Add new blog (optional)</label>
                                <input
                                    type="text"
                                    id="add-new-blog"
                                    name="add-new-blog"
                                    className="field-input"
                                    placeholder="Enter domain name of a new blog" 
                                    value={newBlogValue || ''}
                                    onChange={(e) => setNewBlogValue(e.target.value)}
                                    ></input>
                                    <button className="blue-btn" onClick={(e) => handleAddNewDomain(newBlogValue, e)}>+</button >
                            </div> */}
                            {fullName && (
                                <p className="click-to-copy" onClick={()=> handleCopy(fullName)}>{fullName} {copied && (<span className="click-to-copy-tip">Copied</span>)}</p>
                            )}
                        </div>
                        {!companyNameExists && 
                            <div className="form-section">
                                <h3 className="section-title">{formContent[1].sectionTitle}</h3>
                                {formContent[1].fields.map((field, fieldIndex) => (
                                    <div key={fieldIndex} className={`form-field ${field.type === 'hidden' ? 'visibility-hidden' : null}`}>
                                        <label htmlFor={field.name} className="field-label">{field.label}</label>
                                        <input
                                            type={"text"}
                                            id={field.name}
                                            name={field.name}
                                            className="field-input"
                                            placeholder={field.placeholder} 
                                            value={credentialsValues[field.name] ?? field.value ?? ''}
                                            onChange={(e) => handleCredentialsChange(field.name, e.target.value)}
                                            ></input>
                                    </div>
                                ))}

                                {role === 'admin' && 
                                    <>
                                        <div className="input-block config-item-block checkbox-block ">
                                            <input
                                                type="checkbox"
                                                className="toggle-button"
                                                id="check_credentials"
                                                name="check_credentials"
                                                checked={credentialsCheckbox}
                                                onChange={(e) => setCredentialsCheckbox(e.target.checked)}
                                            />
                                            <label htmlFor="check_credentials" className="toggle-label">
                                                Validate Credentials
                                            </label>
                                        </div>

                                        <div className="input-block config-item-block checkbox-block ">
                                            <input
                                                type="checkbox"
                                                className="toggle-button"
                                                id="has_voluum_account"
                                                name="has_voluum_account"
                                                checked={hasVoluumAccountCheckbox}
                                                onChange={(e) => setHasVoluumAccountCheckbox(e.target.checked)}
                                            />
                                            <label htmlFor="has_voluum_account" className="toggle-label">
                                                Has Voluum Account
                                            </label>
                                        </div>
                                    </>
                                }

                                

                            </div>
                            
                        }

                        {formError && (
                            <div className="error">
                                {formErrorMessage.map((error, index) => (
                                    <p key={index}>{error}</p>
                                ))}
                            </div>
                        )}
                        <button 
                            type="submit"
                            className={`blue-btn ${companyNameExists ? 'disabled-button' : null}`}
                            disabled={companyNameExists}>
                            Submit  
                        </button>
                    </form>
                </div>
            )}

            {successfullSendData && (
                <div className="formContainer">
                    <div className="success-message" onClick={() => {handleCopy(successfullSendDataMessage.join(', '))}}>
                        {successfullSendDataMessage.map((message, index) => (
                            <p key={index}>{message}</p>
                        ))}
                    </div>
                    {copied && (<p className="click-to-copy"><span className="click-to-copy-tip">Copied</span></p>)}
                </div>
            )}
        </>
    )
}

export default ConnectAndVerifyAN;